import {CreateDocumentRequest} from '../models/documents/createDocument.request';
import {UpdateDocumentRequest} from '../models/documents/updateDocument.request';
import {Document} from "../models/documents/document.model";

export namespace Documents {
  export class GetDocuments {
    static readonly type = '[Documents api] Get Documents';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class GetDocument {
    static readonly type = '[Documents api] Get Document Url';

    constructor(public jobId: string, public id: string, public force: boolean = false) {
    }
  }

  export class CreateDocument {
    static readonly type = '[Documents api] Create Document';

    constructor(public jobId: string, public request: CreateDocumentRequest, public file?: File) {
    }
  }

  export class UpdateDocument {
    static readonly type = '[Documents api] Update Document';

    constructor(public jobId: string, public id: string, public request: UpdateDocumentRequest) {
    }
  }

  export class DeleteDocument {
    static readonly type = '[Documents api] Delete Document';

    constructor(public jobId: string, public id: string) {
    }
  }

  export class DeleteDocuments {
    static readonly type = '[Documents api] Delete Documents';
    constructor(public jobId: string, public documents: Document[]) {
    }
  }

  export class DownloadDocumentsZip {
    static readonly type = '[Documents api] Download Documents Zip';
    constructor(public jobId: string, public documents: Document[]) {
    }
  }
}
